import React from 'react'
import { DocumentNode } from 'graphql'
import { PureQueryOptions } from 'apollo-client'
import { ApolloConsumer } from 'react-apollo'
import { SessionMetadataField } from '.'
import { Query } from '../graphql'
import { CollectionVariables } from '../organization-collection-loader'

interface ChildProps {
  readonly sessionMetadataFields: SessionMetadataField[]
  readonly loading: boolean
  readonly queryInfo: PureQueryOptions
}

interface Props {
  readonly query: DocumentNode
  readonly queryRootKey: string
  readonly organizationID: string
  readonly areVariablesEqual?: (
    var1: CollectionVariables,
    var2: CollectionVariables
  ) => boolean
  readonly children: (props: ChildProps) => React.ReactNode
}

interface VarsWithoutAgg {
  readonly organizationID: string
}

type Vars = VarsWithoutAgg

export function SessionMetadataFieldsLoader({
  query,
  queryRootKey,
  organizationID,
  areVariablesEqual,
  children
}: Props) {
  const variables: Vars = Object.assign(
    {},
    {
      organizationID
    }
  )

  return (
    <ApolloConsumer>
      {(client) => (
        <Query<any>
          client={client}
          query={query}
          variables={variables}
          dataKey={queryRootKey}
          areVariablesEqual={areVariablesEqual}
        >
          {({ loading, data: sessionMetadataFields = [] }) =>
            children({
              sessionMetadataFields: sessionMetadataFields.map(
                ({ agentLabel, displayLabel, count }) => ({
                  id: agentLabel,
                  name: displayLabel,
                  count
                })
              ),
              loading,
              queryInfo: {
                query,
                variables
              }
            })
          }
        </Query>
      )}
    </ApolloConsumer>
  )
}
